package com.exura.features.plandefinition.domain.model.metadata

import kotlinx.serialization.Serializable

@Serializable
data class PlanDefinitionFields(
    val title: String,
    val description: String,
    val imageUrl: String?,
)
